
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Login extends Vue {

	mounted()
	{
		// hide page wide loading animation
		this.$store.state.loaded = true;
	}

}
